import createBrowserHistory from 'history/lib/createBrowserHistory';
import createRouterHistory from './createRouterHistory';
export default createRouterHistory(createBrowserHistory);


//////////////////
// WEBPACK FOOTER
// /tw-build/dev/global-site/~/react-router/es/browserHistory.js
// module id = 160
// module chunks = 0